import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import {
    IShuttleStatus,
    IModal,
    ModalType,
} from "Pages/Admin/ShuttleStatus/ShuttleStatus";
import useFetch from "Hooks/useFetch";
import useAlertContext from "Hooks/useAlertContext";

interface IProps {
    getStatuses: () => Promise<void>;
    modal: IModal | undefined;
    onSetModal: (name?: ModalType, row?: IShuttleStatus) => void;
}

export default function RetireModal({
    getStatuses,
    modal,
    onSetModal,
}: IProps) {
    const { post } = useFetch();
    const { newAlert } = useAlertContext();

    if (modal === undefined) return null;

    const closeModal = () => {
        onSetModal();
    };

    const retire = async (row: IShuttleStatus) => {
        const url = `/api/shuttle_status/retire`;
        const body = {
            company_id: row.company_id,
            machine_name: row.machine_name,
            version: row.version,
            tag: row.tag,
            companies_to_process: row.companies_to_process,
            earliest_connection: row.earliest_connection,
            latest_connection: row.latest_connection,
            declared_lost: row.declared_lost,
            retired: row.retired,
        };

        const response = await post(url, body);

        let data: any;
        try {
            data = await response.json();
        } catch {
            data = response;
        }
        console.log(
            `${row.retired ? "Un-retire" : "Retire"} shuttle response: `,
            data
        );

        if (response.ok) {
            getStatuses();
        } else {
            newAlert({ message: "Error (un)retiring shuttle" });
        }
        closeModal();
    };

    return (
        <Modal isOpen={modal.name === "retire"} toggle={closeModal}>
            <ModalHeader toggle={closeModal}>Confirm</ModalHeader>
            <ModalBody>{`Are you sure you want to ${
                modal.row.retired ? "un-" : ""
            }retire ${modal.row.machine_name}?`}</ModalBody>
            <ModalFooter id="modal_footer">
                <Button onClick={() => retire(modal.row)} color="primary">
                    Submit
                </Button>
            </ModalFooter>
        </Modal>
    );
}
